import { Controller } from 'stimulus';
import { normalizeHttpUrl } from '@/js/util';

export default class extends Controller {
  static values = { invalidMessage: String };

  validate() {
    const value = this.element.value.trim();

    this.element.setCustomValidity(
      value && !normalizeHttpUrl(value) ? this.invalidMessageValue : ''
    );
  }

  normalize() {
    const normalized = normalizeHttpUrl(this.element.value);

    if (normalized) {
      this.element.value = normalized;
    }

    this.validate();
  }
}
